export default __webpack_public_path__ + "static/media/url1.72e3c061.png";